<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="105" height="100" viewBox="0 0 105 100">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g :fill="color" fill-rule="nonzero">
        <g>
          <path
            d="M93.326 35.426l11.073-11.082c.457-.456.672-1.101.58-1.74-.09-.639-.477-1.199-1.043-1.51L90.624 13.78c-.993-.545-2.24-.182-2.785.811-.544.994-.182 2.242.81 2.787l10.918 5.999-9.503 9.51-34.18-18.783 9.502-9.51 9.606 5.28c.993.544 2.24.182 2.785-.812.545-.993.182-2.242-.81-2.787L66.01.254c-.8-.44-1.793-.298-2.437.347L52.5 11.684 41.426.601c-.645-.645-1.638-.786-2.437-.348L1.064 21.094c-.566.311-.953.87-1.043 1.51-.092.639.123 1.284.58 1.74l11.073 11.082L.601 46.507c-.457.457-.672 1.102-.58 1.742.09.639.477 1.198 1.043 1.509l11.46 6.298v21.05c0 .75.408 1.44 1.064 1.8l37.925 20.84c.308.17.647.254.987.254.34 0 .68-.084.987-.253l37.925-20.84c.656-.361 1.064-1.05 1.064-1.8V56.056l11.46-6.298c.566-.31.953-.87 1.043-1.51.092-.638-.123-1.284-.58-1.74L93.326 35.426zM52.5 53.925l-33.664-18.5 33.664-18.5 33.664 18.5-33.664 18.5zM39.614 4.593l9.502 9.51-34.18 18.783-9.502-9.51 34.18-18.783zM14.938 37.966l34.18 18.783-9.504 9.51-34.18-18.782 9.504-9.51zm73.436 37.927L54.551 94.48V73.5c0-1.134-.918-2.053-2.051-2.053s-2.05.92-2.05 2.053v20.98L16.625 75.893V58.31L38.989 70.6c.31.17.65.253.986.253.531 0 1.057-.207 1.45-.602L52.5 59.17 63.574 70.25c.394.396.92.602 1.451.602.336 0 .676-.084.986-.254L88.374 58.31v17.583zM65.386 66.26l-9.503-9.512 34.18-18.782 9.504 9.51-34.18 18.784z"
            transform="translate(-745 -234) translate(745 234)"
          />
          <path
            d="M83 14c.526 0 1.04-.214 1.414-.587.372-.372.586-.887.586-1.413 0-.527-.214-1.042-.586-1.414C84.042 10.213 83.526 10 83 10c-.528 0-1.042.213-1.414.586-.374.372-.586.887-.586 1.414 0 .526.212 1.041.586 1.413.372.373.888.587 1.414.587zM52 65c-.526 0-1.042.213-1.414.586-.372.373-.586.887-.586 1.414 0 .527.214 1.041.586 1.416.372.371.888.584 1.414.584.526 0 1.042-.213 1.414-.584.372-.375.586-.889.586-1.416 0-.527-.214-1.04-.586-1.414C53.042 65.213 52.526 65 52 65z"
            transform="translate(-745 -234) translate(745 234)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
